import { render, staticRenderFns } from "./TestMetadataPage.vue?vue&type=template&id=73fdb7e8&scoped=true"
import script from "./TestMetadataPage.vue?vue&type=script&lang=js"
export * from "./TestMetadataPage.vue?vue&type=script&lang=js"
import style0 from "./TestMetadataPage.vue?vue&type=style&index=0&id=73fdb7e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdb7e8",
  null
  
)

export default component.exports